<template>
    <div class="home">
        <div class="floating">
            <div class="widget">
                <div class="level">
                    <div
                        :class="['level-item', { active: active == 0 }]"
                        @click="toggle(0)"
                    >
                        <div class="widget-tab">
                            <div>
                                <img
                                    style="width: 30px; height: 30px"
                                    src="@/assets/images/express.svg"
                                />
                            </div>
                            <span>{{ $t("Express shipping") }}</span>
                        </div>
                    </div>
                    <div
                        :class="['level-item', { active: active == 1 }]"
                        @click="toggle(1)"
                    >
                        <div class="widget-tab">
                            <div>
                                <img
                                    style="width: 30px; height: 30px"
                                    src="@/assets/images/air-freight.svg"
                                />
                            </div>
                            <span>{{ $t("Air freight via airlines") }}</span>
                        </div>
                    </div>
                    <div
                        :class="['level-item', { active: active == 2 }]"
                        @click="toggle(2)"
                    >
                        <div class="widget-tab">
                            <div>
                                <img
                                    style="width: 30px; height: 30px"
                                    src="@/assets/images/ship.svg"
                                />
                            </div>
                            <span>{{ $t("Sea freight") }}</span>
                        </div>
                    </div>
                    <div
                        :class="['level-item', { active: active == 3 }]"
                        @click="toggle(3)"
                    >
                        <div class="widget-tab">
                            <div>
                                <img
                                    style="width: 30px; height: 30px"
                                    src="@/assets/images/club.svg"
                                />
                            </div>
                            <span>{{ $t("ALKOON Partner Program") }}</span>
                        </div>
                    </div>
                    <div
                        :class="['level-item', { active: active == 4 }]"
                        @click="toggle(4)"
                    >
                        <div class="widget-tab">
                            <div>
                                <img
                                    style="width: 30px; height: 30px"
                                    src="@/assets/images/market.svg"
                                />
                            </div>
                            <span>{{ $t("Stores") }}</span>
                        </div>
                    </div>
                </div>
                <div :class="['details-container', `p-${active}`]">
                    <component :is="onView"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Bus } from "../main";
import WidgetExpress from "@/components/Homepage/express.vue";
import WidgetAirlines from "@/components/Homepage/airlines.vue";
import WidgetSea from "@/components/Homepage/sea.vue";
import WidgetClub from "@/components/Homepage/club.vue";

import WidgetStore from "@/components/Homepage/Store.vue";
import WidgetFitBox from "@/components/Homepage/FitBox.vue";
import WidgetOffers from "@/components/Homepage/Offers.vue";

export default {
    components: {
        WidgetExpress,
        WidgetAirlines,
        WidgetSea,
        WidgetClub,
        WidgetStore,
        WidgetFitBox,
        WidgetOffers,
    },
    data() {
        return {
            onView: "widget-express",
            active: 0,
            part: [
                "widget-express",
                "widget-airlines",
                "widget-sea",
                "widget-club",
                "widget-store",
            ],
        };
    },
    methods: {
        toggle(n) {
            this.active = n;
            this.onView = this.part[n];
            Bus.$emit("changebg", this.active);
        },
    },
    created() {
        this.$store.dispatch("countries");
        if (!this.$store.state.user.token) return;
        this.$store.dispatch("userData");
        // .then((res) => {
        //     if (
        //         this.$store.state.user.token &&
        //         !this.$store.state.userData.is_updated
        //     )
        //         return this.$router.push("/verify-data");
        // });
    },
    mounted() {
        if (
            this.$store.state.user.token &&
            !this.$store.state.user.email_verified
        )
            return this.$router.push("/verify");
        if (
            this.$store.state.user.token &&
            !this.$store.state.user.mobile_verified
        )
            return this.$router.push("/verify-mobile");

        this.$store.dispatch("resetSession");
    },
};
</script>

<style lang="scss" scoped>
.home {
    position: relative;
    height: 600px;

    .background-image {
        height: auto;
        max-width: 100%;
    }

    .floating {
        position: absolute;
        top: 60px;
        width: 100%;
        height: 100px;
        text-align: center;
        z-index: 1;

        .widget {
            position: relative;
            background-color: white;
            height: 100%;
            width: 95%;
            display: inline-block;

            .details-container {
                transition: 0.4s ease-out;
                position: absolute;
                background-color: white;
                padding: 20px 15px;
                top: calc(100% + 5px);
                width: 400px;

                @media only screen and (max-width: 600px) {
                    width: 100%;
                }

                &.p-0,
                &.p-1,
                &.p-3 {
                    left: 0;
                }
            }

            .level {
                height: 100%;
                display: flex;

                @media only screen and (max-width: 1000px) {
                    overflow-x: auto;
                    overflow-y: hidden;
                }

                .level-item {
                    position: relative;
                    height: 100%;

                    @media only screen and (max-width: 1000px) {
                        width: 250px;
                    }

                    &::before {
                        transition: 0.4s ease-out;
                        content: "";
                        position: absolute;
                        display: inline-block;
                        bottom: 0;
                        width: 80px;
                        height: 3px;
                        left: calc(50% - 40px);
                        background-color: #bbb;
                        transform: scaleX(0);
                        transform-origin: left;
                    }
                }

                .level-item.active {
                    color: #000;

                    &::before {
                        background-color: #000;
                        transform: scaleX(1) !important;
                    }
                }

                .level-item:hover {
                    &::before {
                        transform: scaleX(1) !important;
                    }
                }
            }
        }
    }

    .widget-tab {
        transition: 0.25s ease-out;
        cursor: pointer;
    }
}
</style>
